// Lightweight i18n for the UI CHROME only (nav, labels, buttons, headings).
// Place CONTENT (establishment names, descriptions, hours text) stays exactly as
// owners entered it — owners translate their own content separately.
//
// English is the KEY: t('Save') returns the Hebrew when the language is 'he',
// otherwise the English string itself — so any string not yet translated
// gracefully falls back to English instead of showing a missing-key.
//
// Switching language persists the choice and reloads (simple + bulletproof:
// every t() re-evaluates and the <html dir> flips for RTL).


// I DIZIONARI SI CARICANO UNO ALLA VOLTA, E SOLO SE SERVONO.
//
// Stavano tutti e tre qui dentro: 113 kB compressi su un bundle di 310, cioè
// un terzo di tutto il JavaScript del sito, scaricati da chiunque aprisse una
// pagina. Chi legge in inglese non ne usa nessuno — l'inglese è la CHIAVE del
// dizionario, non una delle voci — quindi per la maggioranza dei visitatori
// erano peso puro, e la home ci metteva 5,6 secondi a mostrare qualcosa su
// telefono.
//
// Adesso stanno in dict/he.js, dict/fr.js, dict/it.js e li carica
// caricaLingua(), che index.js aspetta prima di disegnare. Aspettare è la
// scelta giusta invece di disegnare subito in inglese e correggere dopo: un
// lampo di inglese su una pagina ebraica, col verso della scrittura che si
// ribalta a metà, è peggio di un decimo di secondo di attesa. Chi apre in
// inglese non aspetta niente, perché non c'è niente da caricare.
let DICT = {};

// Le tabelle dei dati (categorie, livelli di kashrut, nomi di città) seguono
// la stessa strada: sono 16 kB compressi che un lettore inglese non usa.
// LE VOCI SCRITTE A MANO VINCONO, come prima: si aggiungono solo le chiavi
// che il dizionario non ha già, perché una stringa tradotta a mano è stata
// pensata nel suo contesto e una tabella generata non deve passarci sopra.
function aggiungiTabelle(lingua) {
  return Promise.all([import('./data/vocab-i18n'), import('./data/city-i18n')])
    .then(([v, c]) => {
      for (const mod of [v, c]) {
        const tabella = (mod.default || {})[lingua];
        if (!tabella) continue;
        if (!DICT[lingua]) DICT[lingua] = {};
        for (const [en, tr] of Object.entries(tabella)) {
          if (!DICT[lingua][en]) DICT[lingua][en] = tr;
        }
      }
    })
    .catch(() => {});
}

export function caricaLingua(l) {
  const lingua = l || _lang;
  if (!lingua || lingua === 'en' || DICT[lingua]) return Promise.resolve();
  const quale = lingua === 'he' ? import('./dict/he')
    : lingua === 'fr' ? import('./dict/fr')
      : lingua === 'it' ? import('./dict/it')
        : null;
  // SENZA DIZIONARIO LE TABELLE SERVONO LO STESSO, ANZI DI PIU'.
  //
  // Menachem, 26/10/2026: «non hai fatto». Aveva ragione: avevo appena
  // scritto 112 paesi e 92 citta' in spagnolo, russo e tedesco, e sul
  // sito non compariva niente. Qui c'era il motivo — per una lingua
  // senza dizionario dell'interfaccia si usciva SUBITO, e
  // aggiungiTabelle() non veniva mai chiamata. I nomi erano nel file e
  // nessuno li andava a prendere.
  //
  // Sono proprio le tre lingue nuove ad averne piu' bisogno: senza
  // dizionario i bottoni restano inglesi, e l'unica cosa che puo'
  // arrivare tradotta sono i nomi dei paesi e delle citta'.
  if (!quale) return aggiungiTabelle(lingua);
  return quale
    .then((m) => { DICT[lingua] = { ...(m.default || {}) }; return aggiungiTabelle(lingua); })
    // Se il pezzo non arriva (rete che cade, deploy a metà), il sito resta in
    // inglese invece di non aprirsi: t() torna la sua chiave, che è inglese.
    .catch(() => {});
}

// IL VOCABOLARIO DEI DATI, aggiunto da data/vocab-i18n.js.
//
// Questo dizionario traduce la cornice dell'interfaccia e i nomi dei paesi.
// Ma le categorie, i livelli di kashrut e i sottotipi arrivano dal database e
// non erano mai passati da t(): su una pagina in ebraico si leggeva "Kosher
// Restaurant" e "Mehadrin" in caratteri latini, e un lettore francese o
// italiano li vedeva in inglese. Sono le parole che l'utente SCEGLIE nei
// filtri, quindi le più viste del sito.
//
// Le voci scritte a mano qui sopra VINCONO: se una stringa è già tradotta in
// questo file è perché qualcuno l'ha pensata nel suo contesto, e una tabella
// generata non deve passarci sopra.
// (la fusione avviene in aggiungiTabelle(), dopo il caricamento)

// E I NOMI DELLE CITTÀ, da data/city-i18n.js.
//
// Il paese accanto alla città era già tradotto e la città no: su una scheda
// in ebraico si leggeva "ישראל" per il paese e "Jerusalem" per la città.
// La tabella non copre tutte le 2.518 città e non deve: per quasi tutte il
// nome è identico nelle quattro lingue, e t() lascia passare l'inglese
// quando non trova una chiave. Copre l'ebraico — che l'archivio in buona
// parte già conosceva — e gli esonimi veri.
// (idem: aggiungiTabelle())

// SPAGNOLO E RUSSO SI POSSONO SCEGLIERE, MA L'INTERFACCIA RESTA INGLESE.
//
// Menachem, 26/10/2026. Le schede possono gia' portare il nome, la
// descrizione e le note in spagnolo e in russo; il dizionario
// dell'interfaccia — circa 1.630 chiavi a lingua, da far rileggere a un
// madrelingua — non c'e' ancora.
//
// Metterle qui lo stesso non e' una mezza misura: caricaLingua() non
// trova il pezzo, DICT resta vuoto e t() torna la sua chiave, che E'
// l'inglese. Chi sceglie «Español» ottiene quindi bottoni in inglese e
// il contenuto dei posti in spagnolo — che e' meglio di tutto in
// inglese, ed e' il motivo per cui si scrive una traduzione. Senza
// questa riga quelle traduzioni non le vedrebbe nessuno.
//
// Non entrano invece negli hreflang (vedi og-render.js): annunciare a
// Google una pagina «es» con i bottoni in inglese e' farsi contare una
// pagina sottile in una lingua che non parliamo ancora.
export const LANGS = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'he', label: 'עברית', name: 'עברית' },
  { code: 'fr', label: 'FR', name: 'Français' },
  { code: 'it', label: 'IT', name: 'Italiano' },
  { code: 'es', label: 'ES', name: 'Español' },
  { code: 'ru', label: 'RU', name: 'Русский' },
  { code: 'de', label: 'DE', name: 'Deutsch' },
];
const LANG_CODES = new Set(LANGS.map((l) => l.code));

let _lang = 'en';
try { _lang = localStorage.getItem('jc_lang') || 'en'; } catch (e) { /* SSR / blocked storage */ }

// A shareable per-language link: ?lang=fr (or &lang=fr) on ANY page/path forces
// that language for this visitor and remembers it, so e.g.
// jewishcompass.com/list?country=Italy&lang=it always opens in Italian. Runs
// once at module load, before the app's first render.
try {
  if (typeof window !== 'undefined' && window.location) {
    const urlLang = new URLSearchParams(window.location.search).get('lang');
    if (urlLang && LANG_CODES.has(urlLang) && urlLang !== _lang) {
      _lang = urlLang;
      localStorage.setItem('jc_lang', urlLang);
    }
  }
} catch (e) { /* ignore */ }

export const getLang = () => _lang;
export const isRTL = () => _lang === 'he';

// Translate a UI string. English is the key; unknown strings return themselves.
export function t(en) {
  const d = DICT[_lang];
  return (d && d[en]) || en;
}

export function setLang(l) {
  if (!l || l === _lang) return;
  try { localStorage.setItem('jc_lang', l); } catch (e) { /* ignore */ }
  if (typeof window === 'undefined' || !window.location) return;
  // A ?lang= in the URL WINS at startup (see the block above), so a plain
  // reload would put the old language straight back and the switcher would
  // look broken. Rewrite the parameter to the chosen language first — English
  // drops it entirely, since English URLs stay clean.
  try {
    const u = new URL(window.location.href);
    if (u.searchParams.has('lang')) {
      if (l === 'en') u.searchParams.delete('lang');
      else u.searchParams.set('lang', l);
      window.location.replace(u.toString());
      return;
    }
  } catch (e) { /* fall through to a plain reload */ }
  window.location.reload();
}

// Append the current language to a URL for sharing (?lang=fr), so a link opens
// in the same language for whoever it's sent to. Skipped for English (the
// default) to keep plain URLs clean. Adds to whatever query string is already
// there, and never duplicates an existing lang param.
export function withLang(url) {
  if (!url || _lang === 'en') return url;
  try {
    const u = new URL(url, (typeof window !== 'undefined' && window.location) ? window.location.origin : undefined);
    u.searchParams.set('lang', _lang);
    return u.toString();
  } catch (e) { return url; }
}

// The same thing for an in-site path, kept RELATIVE ("/list?country=Italy" →
// "/list?country=Italy&lang=it"). Used on every internal navigation so the
// address bar always states the language: whatever a visitor copies out of it,
// or opens in a new tab, then arrives in the language they were reading. English
// is left alone so ordinary URLs stay clean.
export function withLangPath(path) {
  if (!path || _lang === 'en') return path;
  try {
    // A dummy origin lets URL parse a relative path; only the relative part is
    // handed back, so this never turns an in-site link into an absolute one.
    const u = new URL(path, 'https://jc.invalid');
    u.searchParams.set('lang', _lang);
    return `${u.pathname}${u.search}${u.hash}`;
  } catch (e) { return path; }
}

// Set <html lang/dir> from the persisted language — call once at startup so
// Hebrew renders RTL. (Layout mostly auto-flips; a few components may want
// RTL-aware tweaks later.)
export function applyDir() {
  try {
    document.documentElement.lang = _lang;
    document.documentElement.dir = isRTL() ? 'rtl' : 'ltr';
  } catch (e) { /* ignore */ }
}
